<template>
	<div v-if="$route.query.parameter === 'showReportAutovalidation'">
		<DocumentReportAutovalidation />
	</div>
	<div v-else-if="store.state.featureSet.reportValidatedDocuments && $route.query.parameter === 'showReportFieldSelectionQuality'">
		<DocumentReportFieldSelectionQuality />
	</div>
	<div v-else>
		{{ $t('Squeeze.Reports.ReportsDisabled') }}
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import useSqueezeStore from "@/apps/squeeze/store";
import DocumentReportAutovalidation from "@/apps/squeeze/components/DocumentReportAutovalidation.vue";
import DocumentReportFieldSelectionQuality from "@/apps/squeeze/components/DocumentReportFieldSelectionQuality.vue";

export default defineComponent({
	name: "EmbeddableReports",
	components: {
		DocumentReportFieldSelectionQuality,
		DocumentReportAutovalidation,
	},
	setup() {
		/** Vuex Store */
		const store = useSqueezeStore();

		return {
			store,
		};
	},
});

</script>

<style lang="scss" scoped>

::v-deep(.p-inputtext) {
	padding: 0.7rem 0.7rem;
}

</style>
